import { QueryKeys } from '../../../enums/queryKeys'

export const getQuoteQueryKey = (quoteId?: string) => [QueryKeys.Quotes, quoteId]
